export default __webpack_public_path__ + "static/media/carouselLandscape30.7f8f757f.jpg";